"use client";

import { c as _c } from "react/compiler-runtime";
interface CurationEmptyStateProps {
  readonly curationTitle: string;
  readonly containerClassName?: string | undefined;
  readonly description?: string | undefined;
}
const DEFAULT_CONTAINER_CLASS_NAME = "tw-flex tw-min-h-[20rem] tw-items-center tw-justify-center tw-px-6";
const DEFAULT_DESCRIPTION = "This tab will show the drops added to this curation.";
export default function CurationEmptyState(t0) {
  const $ = _c(10);
  const {
    curationTitle,
    containerClassName: t1,
    description: t2
  } = t0;
  const containerClassName = t1 === undefined ? DEFAULT_CONTAINER_CLASS_NAME : t1;
  const description = t2 === undefined ? DEFAULT_DESCRIPTION : t2;
  let t3;
  if ($[0] !== curationTitle) {
    t3 = <p className="tw-mb-2 tw-text-base tw-font-semibold tw-text-iron-100">{curationTitle} is empty</p>;
    $[0] = curationTitle;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== description) {
    t4 = <p className="tw-mb-0 tw-text-sm tw-text-iron-400">{description}</p>;
    $[2] = description;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <div className="tw-max-w-md tw-rounded-2xl tw-border tw-border-dashed tw-border-iron-700 tw-bg-iron-950/70 tw-px-6 tw-py-8 tw-text-center">{t3}{t4}</div>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== containerClassName || $[8] !== t5) {
    t6 = <div className={containerClassName}>{t5}</div>;
    $[7] = containerClassName;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}